export const getCollectOrderTabUrl = (idx: number) => {
  switch (idx) {
    case 0:
      return "open";
    case 1:
      return "outfordelivery";
    case 2:
        return "failed";
    case 3:
      return "archived";
    default:
      return "open";
  }
};
